import { flow } from 'fp-ts/function';
import { withScopeContext } from '@mews/framework';
import { connectExpandCollapseAll } from './connectExpandCollapseAll';
import { ExpandCollapseAll as ExpandCollapseAllPure } from './ExpandCollapseAll';

export const ExpandCollapseAll = flow(connectExpandCollapseAll, withScopeContext)(ExpandCollapseAllPure);
